import { render } from "./footer.vue?vue&type=template&id=e199d5ce&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=e199d5ce&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e199d5ce"]])

export default __exports__